<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import katex from 'katex'
import 'katex/dist/katex.min.css'

const props = defineProps<{
  formula: string
  display?: boolean
}>()

const mathElement = ref<HTMLElement>()

const renderFormula = () => {
  if (mathElement.value && props.formula) {
    try {
      katex.render(props.formula, mathElement.value, {
        displayMode: props.display || false,
        throwOnError: false,
        errorColor: '#cc0000',
        macros: {
          '\\RR': '\\mathbb{R}',
          '\\NN': '\\mathbb{N}',
          '\\ZZ': '\\mathbb{Z}',
          '\\QQ': '\\mathbb{Q}',
          '\\CC': '\\mathbb{C}',
        },
      })
    }
    catch (error) {
      // Fallback to plain text if rendering fails
      mathElement.value.textContent = props.formula
    }
  }
}

onMounted(() => {
  renderFormula()
})

watch(() => props.formula, () => {
  renderFormula()
})
</script>

<template>
  <span ref="mathElement" class="math-formula" />
</template>

<style scoped>
.math-formula {
  display: inline-block;
  font-size: 0.9em;
  text-align: center;
}

.math-formula .katex {
  font-size: 1em;
}

.math-formula .katex-display {
  margin: 0;
  text-align: center;
}
</style>
